import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../../store/index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/tendersure/risk_management/dashboard',
    name: 'QedRiskManagementDashboard',
    component: () => import('../../views/qed/risk_management/dashboard/Dashboard.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed'
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/risk_management/buyers',
    name: 'QedRiskManagementBuyers',
    component: () => import('../../views/qed/risk_management/Buyers.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/risk_management',
    name: 'QedRiskManagement',
    component: () => import('../../views/qed/risk_management/List.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/risk_management/details/:id',
    name: 'QedRiskManagement_details',
    component: () => import('../../views/qed/risk_management/Details.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/create/risk_management',
    name: 'QedRiskManagement_create_risk_management',
    component: () => import('../../views/qed/risk_management/Create.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/risk_management/create/category/:id',
    name: 'QedRiskManagement_category_create',
    component: () => import('../../views/qed/risk_management/category/Create.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
    path: '/tendersure/risk_management/category/details/risk_id/:category_id',
    name: 'QedRiskManagement_category_details',
    component: () => import('../../views/qed/risk_management/category/Details.vue'),
    beforeEnter: (to, from, next) => {        
      let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_CATEGORY')
      if(obj === true) {
        next()
      } else {
        next({ name: 'permissions-error' }) 
      }
    }
  },
  {
      path: '/tendersure/risk_management/project_management/create_gantt_chart',
      name: 'QedRiskManagementProjectManagementGanttChartCreate',
      component: () => import('../../views/qed/risk_management/project_management/timeline/CreateGanttChart.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
  {
      path: '/tendersure/risk_management/project_management/approved_gantt_chart',
      name: 'QedRiskManagementProjectManagementGanttChartApproved',
      component: () => import('../../views/qed/risk_management/project_management/timeline/ApprovedGanttChart.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
  {
      path: '/tendersure/risk_management/project_management/project_gantt_chart',
      name: 'QedRiskManagementProjectManagementGanttChartProject',
      component: () => import('../../views/qed/risk_management/project_management/timeline/ProjectGanttChart.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
  {
      path: '/tendersure/risk_management/project_management/meetings',
      name: 'QedRiskManagementProjectManagementMeetings',
      component: () => import('../../views/qed/risk_management/project_management/meetings/Meetings.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
  {
      path: '/tendersure/risk_management/project_management/create_meetings',
      name: 'QedRiskManagementProjectManagementMeetingsCreate',
      component: () => import('../../views/qed/risk_management/project_management/meetings/CreateMeetings.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
  {
      path: '/tendersure/risk_management/project_management/meetings/:id/update',
      name: 'QedRiskManagementProjectManagementMeetingsUpdate',
      component: () => import('../../views/qed/risk_management/project_management/meetings/UpdateMeetings.vue'),
      beforeEnter: (to, from, next) => {        
        let obj = store.state.User.userData.user_type === 'qed' && store.state.Auth.privileges.some(privilege => privilege.title === 'MANAGE_JOB')
        if(obj === true) {
          next()
        } else {
          next({ name: 'permissions-error' }) 
        }
      }
  },
]

export default routes;
